/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateAuthClientRequestBody,
  UpdateAuthClientRequestBody$Outbound,
  UpdateAuthClientRequestBody$outboundSchema,
} from "../components/updateauthclientrequestbody.js";

export type UpdateAuthClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type UpdateAuthClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  updateAuthClientRequestBody: UpdateAuthClientRequestBody;
};

/** @internal */
export type UpdateAuthClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const UpdateAuthClientSecurity$outboundSchema: z.ZodMiniType<
  UpdateAuthClientSecurity$Outbound,
  UpdateAuthClientSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function updateAuthClientSecurityToJSON(
  updateAuthClientSecurity: UpdateAuthClientSecurity,
): string {
  return JSON.stringify(
    UpdateAuthClientSecurity$outboundSchema.parse(updateAuthClientSecurity),
  );
}

/** @internal */
export type UpdateAuthClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  UpdateAuthClientRequestBody: UpdateAuthClientRequestBody$Outbound;
};

/** @internal */
export const UpdateAuthClientRequest$outboundSchema: z.ZodMiniType<
  UpdateAuthClientRequest$Outbound,
  UpdateAuthClientRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    updateAuthClientRequestBody: UpdateAuthClientRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      updateAuthClientRequestBody: "UpdateAuthClientRequestBody",
    });
  }),
);

export function updateAuthClientRequestToJSON(
  updateAuthClientRequest: UpdateAuthClientRequest,
): string {
  return JSON.stringify(
    UpdateAuthClientRequest$outboundSchema.parse(updateAuthClientRequest),
  );
}
